import React from "react";
import "./Checkbox.css";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label }) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="switch-input"
      />
      {label && <span className="switch-label">{label}</span>}
      {/* {label && <span className="switch-slider"></span>} */}
    </label>
  );
};

export default Checkbox;
